module.exports = __webpack_public_path__ + "media/images/icons/filled/hourglass-842d924aadf5766e07d2f7ac41e4d07c.svg";